import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatearCodigoCeros'
})
export class FormatearCodigoCerosPipe implements PipeTransform {
  // Anade ceros previos a un codigo
  // | formatearCodigoCeros o | formatearCodigoCeros:8  donde 8 es el num digitos
  transform(value: number, length: number = 6): string {
    return value.toString().padStart(length, '0');
  }


}
